export default "__VITE_ASSET__CWMGD33W__"